import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';
import { FormTextField } from '../../../../components';

import { getI18n } from "../../../../utils/intl";

import styles from './styles';

const CustomTextInput = (props) => {
  const { days, handleInputChange, handleEnterKey, disabled, typeError, rangeError } = props;
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const intl = getI18n(useIntl());

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    }
  }, []);

  const handleKeyDown = event => {
    if (event.keyCode === 13 && event.target.type === 'number') {
      handleEnterKey();
    }
  };

  const handleChange = (value) => {
    handleInputChange(value, false, false);
  };

  const helperText = typeError ?
    intl.getI18nMessage('label.analyticsDashboard.filter.dateRange.customDay.typeErrorMsg')
      :
    intl.getI18nMessage('label.analyticsDashboard.filter.dateRange.customDay.message');
  const hasError = !disabled && (rangeError || typeError);
  return (
    <div className={classes.root}>
      <FormTextField
        className={classes.textInput}
        disabled={disabled}
        error={hasError}
        errorHelperText={hasError}
        handleChange={handleChange}
        helperText={helperText}
        id='custom-date-range-filters-custom-text'
        type={'number'}
        value={days}
      />
      <div className={classes.daysLabel}>
        {intl.getI18nMessage('label.analyticsDashboard.filter.dateRange.last.choice.days')}
      </div>
    </div>
  );
};

CustomTextInput.propTypes = {
  days: PropTypes.string,
  disabled: PropTypes.bool,
  handleEnterKey: PropTypes.func,
  handleInputChange: PropTypes.func,
  rangeError: PropTypes.bool,
  typeError: PropTypes.bool,
};

export default CustomTextInput;
